import { DATASOURCE } from 'Constants'

const initialState = {
  raw: {}, 
  series: [],
  categories: [],
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DATASOURCE.ACTIVE_CALLS.LOADING:
      return {
        ...state,
        loading: true,
        raw: {},
        series: [],
        categories: []
      };
    case DATASOURCE.ACTIVE_CALLS.KEY:
      let chartData = getChartData(action.data);
      return {
        ...state,
        loading: false,
        raw: action.data,
        series: chartData.series,
        categories: chartData.categories
      };
    default:
      return state;
  }
}

function getChartData(activeCalls) {
  let chartData = { series: [], categories: [] };
  if (!activeCalls || !activeCalls.buckets) {
    return chartData;
  }


  let deployments = {};
  let categories = [];
  let series = {};
  activeCalls.buckets.forEach(b => {
    deployments[b.key] = true;
    b.protocol.buckets.forEach(p => {
      if (!series.hasOwnProperty(p.key)) {
        series[p.key] = {name: p.key, total: 0, data: []};
      }
    });
  });
  let idx = 0;
  Object.keys(deployments).sort().forEach(d => {
    deployments[d] = idx++;
    categories.push(d);
    Object.keys(series).forEach(k => {
      series[k].data.push(0);
    });
  });

  activeCalls.buckets.forEach(bucket => {
    let bKey = bucket.key;
    bucket.protocol.buckets.forEach(protocol => {
      let pKey = protocol.key;
      series[pKey].total += protocol.doc_count;
      series[pKey].data[deployments[bKey]] += protocol.doc_count;
    });
  });

  let topCalls = Object.values(series);
  topCalls.sort((a,b) => a.name.localeCompare(b.name));

  return { series: topCalls, categories: categories };
}
